export default __webpack_public_path__ + "static/media/As The Prescript Orders.ef123e33.png";